<template>
<div style="text-align:left;">
  <TopNav />
  <div class="column-left">
    <SideNav />
  </div>

  <div class="column-right">
    <div v-if="admin_datos.superadmin" class="main-container">
      <div v-if="estado == 0">
        <div v-if="!loading" class="articulo-principal">
          <h2>Editar Post de blog</h2>
          Título:<br/>
          <input type="text" v-model="titulo"><br/><br/>
          Imagen portada:<br/>
          <input type="text" v-model="img_portada"><br/><br/>
          Abstract:<br/>
          <textarea v-model="abstract" placeholder="Resumen que aparecerá para cliquear el post." rows="4" cols="50"></textarea> <br/>
          <br/>
          Tags:
          <div v-on:click="addTag(c.id)" style="display: inline-block; cursor: pointer; margin: 0px 2px; border: 1px solid black; border-radius: 4px; padding: 0px 6px;"
            :style="{
              'background-color': tags.includes(c.id) ? '#008CBA' : '',
              'color': tags.includes(c.id) ? 'white' : '',
            }"
            v-for="c in categorias" :key="c.id">
            {{ c.nombre }}
          </div>
          <br/>
          <br/>

          Contenido:<br/>
          <!-- Tabs -->
          <div class="editor-tabs">
            <button
              :class="{ 'active-tab': activeEditorTab === 'wysiwyg' }"
              @click="switchTab('wysiwyg')"
              class="tab-button">
              Editor Visual
            </button>
            <button
              :class="{ 'active-tab': activeEditorTab === 'html' }"
              @click="switchTab('html')"
              class="tab-button">
              HTML
            </button>
          </div>

          <!-- Editor Areas -->
          <div v-if="activeEditorTab === 'wysiwyg'" class="editor-container">
             <!-- Quill Editor -->
            <vue-editor
              ref="editor"
              :editorToolbar="customToolbar"
              :editorOptions="editorOptions"
              v-model="content">
            </vue-editor>
          </div>
          <div v-if="activeEditorTab === 'html'" class="editor-container">
            <!-- Simple Textarea for HTML -->
            <textarea
              ref="htmlTextarea"
              v-model="content"
              class="html-editor-textarea"
              placeholder="Edita el HTML directamente aquí..."
              spellcheck="false"
              >
            </textarea>
          </div>

          <br/>
          <button v-on:click="enviarPost()" class="btn-std-2">Guardar Post</button>
        </div>
        <div class="loader-cnt" v-else>
          <LoaderBarra :width="100" :height="100"/>
        </div>
      </div>
      <div v-else-if="estado==1">
        <h1>¡Se ha editado el post exitosamente! 🎉</h1>
         <button @click="resetState" class="btn-std-2" style="margin-top: 15px;">Editar de Nuevo</button>
      </div>
      <div v-else>
        <h1>Ha ocurrido un error inesperado</h1>
         <button @click="resetState" class="btn-std-2" style="margin-top: 15px;">Intentar de Nuevo</button>
      </div>
    </div>
     <div v-else>
       <p>Acceso denegado.</p>
     </div>
  </div>
</div>
</template>

<script>
import axios from 'axios';
import { mapGetters, mapActions } from 'vuex';
import SideNav from '@/components/SideNav.vue';
import TopNav from '@/components/TopNav.vue';
import { VueEditor } from "vue2-editor";
import LoaderBarra from '@/components/LoaderBarra.vue';

// Import js-beautify for HTML formatting
import { html as beautifyHtml } from 'js-beautify';

export default {
  name: 'EditBlogPost',
  props:['id'],
  components: {
    SideNav,
    TopNav,
    VueEditor,
    LoaderBarra,
  },
  data() {
    return {
      loading: false,
      loaded: false,
      content: '',
      titulo: '',
      img_portada: '',
      abstract: '',
      estado: 0, // 0: editing, 1: success, 2: error
      tags: [],
      activeEditorTab: 'html', // Default to raw HTML so semantic blog markup is not normalized by Quill.
      // Ensure 'customImage' is in the toolbar config
      customToolbar: [
        ['bold', 'italic', 'underline', 'strike'], ['blockquote', 'code-block'],
        [{ 'header': 1 }, { 'header': 2 }], [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        [{ 'script': 'sub'}, { 'script': 'super' }], [{ 'indent': '-1'}, { 'indent': '+1' }],
        [{ 'direction': 'rtl' }], [{ 'size': ['small', false, 'large', 'huge'] }],
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        [{ 'color': [] }, { 'background': [] }], [{ 'font': [] }], [{ 'align': [] }],
        ['clean'], ['link', 'image', 'video', 'formula'],
        ['customImage'] // Make sure your custom button ID is here
      ],
      editorOptions: {
        // Add any Quill specific options here if needed
      },
      beautifyOptions: { // Options for formatting the HTML textarea
        indent_size: 2,
        indent_char: ' ',
        max_preserve_newlines: 1,
        preserve_newlines: true,
        keep_array_indentation: false,
        break_chained_methods: false,
        indent_scripts: 'normal',
        brace_style: 'collapse',
        space_before_conditional: true,
        unescape_strings: false,
        jslint_happy: false,
        end_with_newline: true,
        wrap_line_length: 0,
        indent_inner_html: true,
        comma_first: false,
        e4x: false,
        indent_empty_lines: false,
        extra_liners: ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'hr', 'ul', 'ol', 'div', 'table', 'blockquote', 'pre', 'img']
      }
    }
  },
  computed:{
    ...mapGetters(['comunas', 'categorias', 'regiones', 'tipos', 'admin_datos']),
  },
  methods:{
    ...mapActions(['initialize']), // Assuming 'initialize' fetches categories etc. from Vuex

    resetState() {
        this.estado = 0;
    },

    formatHtmlContent() {
      // Pre-process and format HTML for the textarea view
      if (this.content && typeof this.content === 'string') {
        try {
          let cleanedHtml = this.content;
          const emptyOrBrParaRegex = /<p>\s*(?:<br\s*\/?>)?\s*<\/p>/gi;
          let prevHtml;
          do {
             prevHtml = cleanedHtml;
             cleanedHtml = cleanedHtml.replace(emptyOrBrParaRegex, '');
          } while (cleanedHtml !== prevHtml);

          const formattedHtml = beautifyHtml(cleanedHtml, this.beautifyOptions);
          if (formattedHtml !== this.content) {
             this.content = formattedHtml;
          }
        } catch (error) {
          console.error("Error formatting HTML:", error);
        }
      }
      this.$nextTick(() => { /* Ensure textarea updates if needed */ });
    },

    shouldPreferHtmlEditor(html) {
      if (!html || typeof html !== 'string') {
        return false;
      }
      return /<\/?(article|aside|figcaption|figure|footer|header|main|nav|section)\b/i.test(html);
    },

    switchTab(tabName) {
      if (tabName === 'wysiwyg' && this.shouldPreferHtmlEditor(this.content)) {
        const confirmed = window.confirm('Este post contiene etiquetas HTML semánticas que el editor visual puede modificar o eliminar. ¿Quieres abrirlo igual en el editor visual?');
        if (!confirmed) {
          return;
        }
      }

      let textareaScrollTop = 0;
      if (this.activeEditorTab === 'html' && this.$refs.htmlTextarea) {
         textareaScrollTop = this.$refs.htmlTextarea.scrollTop;
      }

      this.activeEditorTab = tabName;

      if (tabName === 'html') {
        this.$nextTick(() => {
            this.formatHtmlContent(); // Format content for textarea
            if (this.$refs.htmlTextarea) { // Restore scroll position
               this.$refs.htmlTextarea.scrollTop = textareaScrollTop;
            }
        });
      } else if (tabName === 'wysiwyg') {
        // Crucial: Re-run the custom button setup when switching back to WYSIWYG
        this.$nextTick(() => {
             this.addCustomImageButtonHandler();
        });
      }
    },

    enviarPost(){
      if (!this.titulo || !this.content) {
         alert('Por favor, completa el título y el contenido.');
         return;
      }
      this.loading = true;
      this.estado = 0; // Reset state before sending
      axios.post(window.hostname+'api/superadmin/editar_post', {
            id: this.$route.params.id,
            contenido: this.content, // Content is synced via v-model
            titulo: this.titulo,
            abstract: this.abstract,
            etiquetas: this.tags,
            img_portada: this.img_portada,
      })
      .then(response => {
        console.log("Post editado:", response.data);
        this.loading = false;
        this.estado = 1;
      })
      .catch(e => {
        console.error("Error al editar post:", e);
        this.loading = false;
        this.estado = 2;
      });
    },

    initialize_(){
      // Fetch post data by ID
      this.loading = true;
      this.loaded = false;
      axios.post(window.hostname + 'api/superadmin/post_por_id', {
          id: this.$route.params.id
      })
      .then(response => {
        if (response.data && response.data.post) {
            const post = response.data.post;
            console.log("Post data recibido:", post);
            const postContent = post.contenido || '';
            this.activeEditorTab = this.shouldPreferHtmlEditor(postContent) ? 'html' : 'wysiwyg';
            this.content = postContent;
            this.titulo = post.titulo || '';
            this.abstract = post.abstract || '';
            this.tags = post.etiquetas || [];
            this.img_portada = post.img_portada || '';
            this.loaded = true;
        } else {
            console.error("Error: Post data not found in response");
            this.estado = 2;
        }
        this.loading = false;
      })
      .catch(e => {
        this.loading = false;
        this.loaded = true;
        this.estado = 2;
        console.error("Error al cargar el post:", e);
      });
    },

    addTag(value){
      // Add/remove tag from the tags array
      const index = this.tags.indexOf(value);
      if (index === -1) {
        this.tags.push(value);
      } else {
        this.tags.splice(index, 1);
      }
    },

    // --- Custom Image Button Handler ---
    addCustomImageButtonHandler() {
      // Use nextTick to ensure DOM is updated after potential v-show changes
      this.$nextTick(() => {
        // Check if the editor ref and quill instance exist
        if (this.$refs.editor && this.$refs.editor.quill) {
          // Find the toolbar container within the Quill editor element
          const editorElement = this.$refs.editor.$el; // Get the root element of the VueEditor component
          const toolbar = editorElement ? editorElement.querySelector('.ql-toolbar') : null;

          if (toolbar) {
             // Find the button with the specific class Quill assigns based on the toolbar config
             const customButton = toolbar.querySelector('.ql-customImage'); // Class matches the name in customToolbar

             if (customButton) {
                // Set the innerHTML (use SVG for better scaling/consistency)
               customButton.innerHTML = '<img src="https://cdn4.iconfinder.com/data/icons/social-media-black-white-2/600/Instagram_glyph_svg-512.png" alt="Image" style="max-width: 24px;" />'
                // Ensure listener is only added once to prevent duplicates
                if (!customButton.dataset.listenerAdded) {
                   customButton.addEventListener('click', this.insertImageByUrl);
                   customButton.dataset.listenerAdded = 'true'; // Mark as added
                }
             } else {
                 // Only log if you expect it to be there and it isn't
                 // console.warn("Custom image button (.ql-customImage) not found in toolbar.");
             }
          } else {
              console.warn("Quill toolbar (.ql-toolbar) not found.");
          }
        } else {
           // console.warn("Quill editor or instance not ready for custom button setup.");
        }
      });
    },

    insertImageByUrl() {
  const url = prompt('Enter the image URL');
  const alt = prompt('Enter the ALT text for the image');
  
  if (url) {
    const range = this.$refs.editor.quill.getSelection(true);
    if (range) {
      const html = `<img src="${url}" alt="${alt || ''}" />`;
      this.$refs.editor.quill.clipboard.dangerouslyPasteHTML(range.index, html);
      this.$refs.editor.quill.setSelection(range.index + 1);
    }
    this.$refs.editor.quill.focus();
  }
}
  },
  mounted() {
    // Ensure user is authorized
    if (!this.admin_datos || !this.admin_datos.superadmin) {
      console.warn("Acceso denegado: Usuario no es superadmin.");
      this.$router.push('/'); // Redirect if not superadmin
      return; // Stop execution
    }

    // Initialize necessary global data (like categories from Vuex) if needed
    this.initialize();

    // Fetch the specific post data
    this.initialize_();

    // Initial setup for the custom Quill button AFTER editor is likely mounted
    // Use a slight delay or rely on the watcher if data loading is very slow
     this.addCustomImageButtonHandler();
     // Could also add: setTimeout(this.addCustomImageButtonHandler, 500); if issues persist
  },
  watch:{
    // Re-fetch data if the route ID changes
    '$route.params.id': function(newId, oldId) {
        if (newId !== oldId) {
            this.initialize_();
        }
    },
    // Watch the content loading state to ensure button is added after editor is ready
    // This can be an alternative or addition to calling it in mounted/switchTab
    loaded(isLoaded) {
        if (isLoaded && this.activeEditorTab === 'wysiwyg') {
            this.addCustomImageButtonHandler();
        }
    }
  }
}
</script>

<style scoped>
/* Layout and General Styles */
td{ text-align: left; }
.articulo-principal{ margin-bottom: 20px; }
table { margin-left: auto; margin-right: auto; }
.column-right{ background-color: rgb(242, 247, 251); padding-top:80px; padding-left:260px; width:100%; min-height: 100vh; box-sizing: border-box; }
.main-container{ background-color: white; margin-top:10px; padding:20px; box-shadow: 0 2px 4px rgba(0,0,0,0.1); border-radius: 4px; }
.loader-cnt { display: flex; justify-content: center; align-items: center; min-height: 200px; }
.btn-std-2 { padding: 10px 15px; background-color: #007bff; color: white; border: none; border-radius: 4px; cursor: pointer; font-size: 1rem; }
.btn-std-2:hover { background-color: #0056b3; }

/* Tab styles */
.editor-tabs { margin-bottom: 10px; border-bottom: 1px solid #ccc; padding-bottom: 0; }
.tab-button { padding: 8px 15px; margin-right: 5px; margin-bottom: -1px; border: 1px solid #ccc; border-bottom: none; background-color: #f0f0f0; cursor: pointer; border-radius: 4px 4px 0 0; outline: none; }
.tab-button.active-tab { background-color: white; border-color: #ccc; border-bottom: 1px solid white; font-weight: bold; }

/* Container for editors */
.editor-container {
    border: 1px solid #ccc;
    min-height: 350px;
    margin-bottom: 15px;
    padding: 5px;
    box-sizing: border-box;
}

/* Styles for the HTML Textarea */
.html-editor-textarea {
    width: 100%;
    height: 340px; /* Adjust height as needed */
    min-height: 340px;
    box-sizing: border-box;
    border: none;
    outline: none;
    padding: 10px;
    font-family: 'Courier New', Courier, monospace;
    font-size: 0.9em;
    line-height: 1.4;
    resize: vertical;
    background-color: #f9f9f9;
    color: #333;
    white-space: pre;
    overflow-wrap: normal;
    overflow: auto; /* Ensure scrollbar appears */
}

/* Ensure Quill editor also fits well and has min height */
.editor-container .ql-container.ql-snow {
    min-height: 330px; /* Adjust to fit inside padding */
    border: none; /* Remove Quill's default border if container has one */
}
.editor-container .ql-toolbar.ql-snow {
    border-top: none; /* Adjust Quill borders as needed */
    border-left: none;
    border-right: none;
    border-bottom: 1px solid #ccc; /* Keep bottom border for separation */
    padding: 8px;
}


/* Responsive adjustments */
@media (max-width: 800px) {
  .column-right{ padding-left: 10px; padding-right: 10px; }
  .main-container{ margin-top: 5px; padding: 15px; }
  .html-editor-textarea { height: 300px; min-height: 300px; }
  .editor-container .ql-container.ql-snow { min-height: 280px; }
}
</style>
